import { Router } from './router';
import LinkToDebrief from 'ff/debrief/router/links/LinkToDebrief';
import LinkToHome from 'ff/debrief/router/links/LinkToHome';
import LinkToShared from 'ff/debrief/router/links/LinkToShared';
import LinkToSharedHome from 'ff/debrief/router/links/LinkToSharedHome';
import LinkToSharedDebrief from 'ff/debrief/router/links/LinkToSharedDebrief';
import RedirectToShared from 'ff/debrief/router/links/RedirectToShared';
import { RouteContext } from 'ff/debrief/router/RouteContext';
export {
    LinkToDebrief,
    LinkToHome,
    LinkToShared,
    LinkToSharedHome,
    LinkToSharedDebrief,
    RouteContext,
    RedirectToShared,
};
export default Router;
